var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = "/monitoring";
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"7c2e3dcb5aff6b76162f455c8e1089487bad772e"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import {
  BrowserClient,
  Dedupe,
  Replay,
  Breadcrumbs,
  HttpContext,
  BrowserTracing,
  defaultStackParser,
  getCurrentHub,
  makeFetchTransport,
} from '@sentry/nextjs';

import { SENTRY_DSN, SENTRY_ENABLE } from '@/next.constants.mjs';

// This creates a custom Sentry Client with minimal integrations
export const sentryClient = new BrowserClient({
  // Only run Sentry on Vercel Environment
  enabled: SENTRY_ENABLE,
  // Provide Sentry's Secret Key
  dsn: SENTRY_DSN,
  // Sentry's Error Transport Mechanism
  transport: makeFetchTransport,
  // Sentry's Stack Trace Parser
  stackParser: defaultStackParser,
  // All supported Integrations by us
  integrations: [
    new Replay(),
    new Dedupe(),
    new HttpContext(),
    new Breadcrumbs(),
    new BrowserTracing(),
  ],
  // We only want to capture errors from _next folder on production
  // We don't want to capture errors from preview branches here
  allowUrls: ['https://nodejs.org/_next'],
  // Enables Sentry Tracing Feature
  enableTracing: true,
  // Percentage of events to send to Sentry (1% of them) (for performance metrics)
  tracesSampleRate: 0.01,
  // Percentage of events to send to Sentry (1% of them) (for session replays)
  replaysSessionSampleRate: 0.01,
  // Percentage of events to send to Sentry (1% of them) (for session replays when error happens)
  replaysOnErrorSampleRate: 1.0,
  // Adds custom filtering before sending an Event to Sentry
  beforeSend: (event, hint) => {
    // Attempts to grab the original Exception before any "magic" happens
    const exception = hint.originalException as Error;

    // We only want to capture Errors that have a Stack Trace and that are not Anonymous Errors
    if (exception?.stack && !exception.stack.includes('<anonymous>')) {
      return event;
    }

    return null;
  },
});

// Attaches this Browser Client to Sentry
getCurrentHub().bindClient(sentryClient);
